export default __webpack_public_path__ + "static/media/buyBestBanner5.9e9f1d11.png";